import React, {Component} from 'react';
import {Button, Drawer, Input, message, Modal, Row, Select, Table} from 'antd';
import {connect} from 'react-redux';
import {
  queryDeleteHr,
  queryDisableHr,
  queryEnableHr,
  queryImportHr,
  queryRegisterHr,
  queryResetHr,
  querySaveHr,
} from '@api/hr/hr';

import FormStaff from './FormStaff';
import ModalImport from './ModalImport';

const { Search } = Input;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      importVisible: false,
      detail: {},
      tips: {},
    };
  }

  componentDidMount() {
    this.current = 1;
  }

  getHr = () => {
    this.props.getHr();
  };

  importHr = params => {
    queryImportHr(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          tips: res.data,
        });
        this.handleImportVisible(false);
        this.handleTipVisible(true);
        this.getHr();
      } else {
        message.error(res.message);
      }
    });
  };

  saveHr = params => {
    querySaveHr(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleVisible(false);
        this.getHr();
      } else {
        message.error(res.message);
      }
    });
  };

  deleteHr = uuid => {
    queryDeleteHr({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleVisible(false);
        this.getHr();
      } else {
        message.error(res.message);
      }
    });
  };

  registerHr = params => {
    queryRegisterHr(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleVisible(false);
        this.getHr();
      } else {
        message.error(res.message);
      }
    });
  };

  disableHr = uuid => {
    queryDisableHr({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleVisible(false);
        this.getHr();
      } else {
        message.error(res.message);
      }
    });
  };

  resetHr = uuid => {
    queryResetHr({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleVisible(false);
        this.getHr();
      } else {
        message.error(res.message);
      }
    });
  };

  enableHr = uuid => {
    queryEnableHr({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.handleVisible(false);
        this.getHr();
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    const { noEdit } = this.props;
    return [
      {
        title: '姓名',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          return noEdit ? (
            <span>{text}</span>
          ) : (
            <a onClick={() => this.handleAdd(record)}>{record.name}</a>
          );
        },
      },
      {
        title: '公司部门',
        dataIndex: 'comName',
        key: 'comName',
        render: (text, record) => (
          <span>
            {record.comName}
            {record.deptName}
          </span>
        ),
      },
      {
        title: '岗位',
        dataIndex: 'post',
        key: 'post',
      },
      {
        title: '手机号码',
        key: 'mobile',
        dataIndex: 'mobile',
      },
      {
        title: '状态',
        key: 'status',
        dataIndex: 'status',
        render: (text, record) => {
          return (
            <span>
              {text === 0 ? (
                <span style={{ color: 'red' }}>已禁用</span>
              ) : (
                <span style={{ color: 'green' }}>已启用</span>
              )}
            </span>
          );
        },
      },
    ];
  };

  handleVisible = flag => {
    this.setState({
      visible: !!flag,
    });
  };

  handleImportVisible = flag => {
    this.setState({
      importVisible: !!flag,
    });
  };

  handleTipVisible = flag => {
    this.setState({
      tipVisible: !!flag,
    });
  };

  handleAdd = detail => {
    this.uuid = detail.uuid;
    this.setState({
      detail,
    });
    this.handleVisible(true);
  };

  onClose = () => {
    this.handleVisible(false);
  };

  handleSearch = value => {
    if (this.condition !== value) {
      this.condition = value;
      this.props.handleSearch(value);
    }
  };

  onTableChange = pagination => {
    this.current = pagination.current;
    this.getHr();
  };

  render() {
    const {
      data: { list, pagination },
      noEdit,
    } = this.props;
    const { visible, importVisible, detail, tips, tipVisible } = this.state;
    return (
      <div className="componentStaff">
        <Row type="flex" justify={noEdit ? 'end' : 'space-between'}>
          {noEdit ? null : (
            <div>
              <Button
                icon="plus"
                style={{ marginBottom: 15, marginRight: 8 }}
                onClick={() => this.handleAdd({})}
              >
                新增
              </Button>
              <Button
                icon="import"
                style={{ marginBottom: 15, marginRight: 8 }}
                onClick={() => this.handleImportVisible(true)}
              >
                导入
              </Button>
              <Button
                icon="export"
                style={{ marginBottom: 15, marginRight: 8 }}
                onClick={() => this.props.exportHr()}
              >
                导出
              </Button>
            </div>
          )}
          <div style={{ marginBottom: 15 }}>
            {this.props.type === 'hr' ? (
              <Select
                placeholder="人员分类"
                style={{ width: '200px' }}
                onChange={this.props.ChangeStatus}
                defaultValue="1"
              >
                <Select.Option value="2">全部人员</Select.Option>
                <Select.Option value="0">已禁用人员</Select.Option>
                <Select.Option value="1">已启用人员</Select.Option>
              </Select>
            ) : null}
            <Search
              placeholder="输入关键字搜索"
              onSearch={value => this.handleSearch(value)}
              style={{ width: 200, marginLeft: '15px' }}
              onBlur={e => this.handleSearch(e.target.value)}
            />
          </div>
        </Row>
        <Table
          style={{ background: '#fff' }}
          rowSelection={{}}
          rowKey="uuid"
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.props.handleTableChange}
        />
        {visible ? (
          <Drawer
            title={detail.uuid ? '编辑员工' : '新增员工'}
            placement="right"
            closable
            visible={visible}
            onClose={this.onClose}
            width={680}
          >
            <FormStaff
              saveHr={this.saveHr}
              registerHr={this.registerHr}
              resetHr={this.resetHr}
              disableHr={this.disableHr}
              enableHr={this.enableHr}
              deleteHr={this.deleteHr}
              orgUuid={this.props.orgUuid}
              uuid={this.uuid}
            />
          </Drawer>
        ) : null}
        <ModalImport
          visible={importVisible}
          handleSubmit={this.importHr}
          handleCancel={() => this.handleImportVisible(false)}
        />
        <Modal
          title="提示"
          footer={false}
          visible={tipVisible}
          onCancel={() => this.handleTipVisible(false)}
        >
          <p>{`上传总数${tips.total},失败${tips.remain},成功${tips.update}`}</p>
          <p>{tips.warning ? `失败原因:${tips.warning}` : null}</p>
        </Modal>
      </div>
    );
  }
}

export default connect(state => ({ data: state.staff_list }))(Index);



// WEBPACK FOOTER //
// ./src/components/hr/staff/ComponentStaff.js